"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoyaltyReportSchema = exports.LoyaltyTierRowSchema = exports.LoyaltyExpiringPointsRowSchema = exports.LoyaltyTopEarnerRowSchema = void 0;
const zod_1 = require("zod");
exports.LoyaltyTopEarnerRowSchema = zod_1.z.object({
    customerId: zod_1.z.string(),
    name: zod_1.z.string(),
    pointsEarned: zod_1.z.number(),
    transactions: zod_1.z.number(),
    lastVisitAt: zod_1.z.string().optional(),
});
exports.LoyaltyExpiringPointsRowSchema = zod_1.z.object({
    customerId: zod_1.z.string(),
    name: zod_1.z.string(),
    points: zod_1.z.number(),
    expiresAt: zod_1.z.string(),
});
exports.LoyaltyTierRowSchema = zod_1.z.object({
    tierId: zod_1.z.string(),
    tierName: zod_1.z.string(),
    memberCount: zod_1.z.number(),
    pointsEarned: zod_1.z.number(),
    pointsRedeemed: zod_1.z.number(),
});
exports.LoyaltyReportSchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    locationId: zod_1.z.string(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    enabled: zod_1.z.boolean().default(true),
    message: zod_1.z.string().optional(),
    totalMembers: zod_1.z.number(),
    activeMembers: zod_1.z.number(),
    newSignups: zod_1.z.number(),
    pointsEarned: zod_1.z.number(),
    pointsRedeemed: zod_1.z.number(),
    pointsBalance: zod_1.z.number(),
    redemptionRatePct: zod_1.z.number(),
    topEarners: zod_1.z.array(exports.LoyaltyTopEarnerRowSchema),
    expiringPoints: zod_1.z.array(exports.LoyaltyExpiringPointsRowSchema),
    byTier: zod_1.z.array(exports.LoyaltyTierRowSchema),
});
//# sourceMappingURL=loyalty-report.schema.js.map